import type React from 'react';
import Modal, { type Props } from 'react-modal';
import * as st from './styles.module.scss';

Modal.setAppElement('#root');

interface ModalProps extends Props {
  children?: React.ReactNode;
}

export const MediumModal: React.FC<ModalProps> = ({ children, ...props }) => {
  return (
    <Modal className={st.modal} overlayClassName={st.overlay} {...props}>
      {children}
    </Modal>
  );
};
